import React, { useState } from "react";
import { Switch } from "antd";

function AntdSwitch({ onChange, defaultChecked }) {
  const [isActive, setsActive] = useState(defaultChecked);
  return (
    <Switch
      style={{
        backgroundColor: isActive && "var(--primary-color)",
      }}
      defaultChecked={defaultChecked}
      onChange={() => {
        setsActive(!isActive);
        onChange();
      }}
    />
  );
}

export default AntdSwitch;
